// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` #MainRoOne {
margin-left: 100px;

  margin-top: 10px;
}
#firstRoTwo {
    background-color: #E6E6FA;
    margin: auto;
}
 
#activeTitileArrow {
  font-size: 50px;
  color: rgb(61, 90, 149);
  margin-top: 20px;
}

#firstCarOne {
    text-align: center;
    border: 0px;
    padding-top: 15px;
    background-color: #E6E6FA;
}
#activeIcon {
    font-size: 24px;
    color: rgb(255, 255, 255);
    margin-top: 0;
    display: block;
    background-color: #3d5a95;
    height: 60px;
    width: 60px;
    line-height: 60px;
    border-radius: 50%;
    margin-bottom: 10px;
}
#activeIcon1 {
  font-size: 50px;
  color: rgb(255, 255, 255);
  margin-top: 30px;
}
#normalIcon1 {
  font-size: 50px;
  color: rgb(255, 255, 255);
  margin-top: 30px;
}
#normalIcon {
  font-size: 24px;
  color: rgb(255, 255, 255);
  margin-top: 25px;
}
#inActiveTab {
  background-color: rgb(243, 242, 238);
  border-radius: 50%;
  text-align: center;
}
#inActiveArrow {
  font-size: 50px;
  color: rgb(243, 242, 238);
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/SidebarComponent/ICICI/ICICIProposeiinfo.css"],"names":[],"mappings":"CAAC;AACD,kBAAkB;;EAEhB,gBAAgB;AAClB;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB","sourcesContent":[" #MainRoOne {\r\nmargin-left: 100px;\r\n\r\n  margin-top: 10px;\r\n}\r\n#firstRoTwo {\r\n    background-color: #E6E6FA;\r\n    margin: auto;\r\n}\r\n \r\n#activeTitileArrow {\r\n  font-size: 50px;\r\n  color: rgb(61, 90, 149);\r\n  margin-top: 20px;\r\n}\r\n\r\n#firstCarOne {\r\n    text-align: center;\r\n    border: 0px;\r\n    padding-top: 15px;\r\n    background-color: #E6E6FA;\r\n}\r\n#activeIcon {\r\n    font-size: 24px;\r\n    color: rgb(255, 255, 255);\r\n    margin-top: 0;\r\n    display: block;\r\n    background-color: #3d5a95;\r\n    height: 60px;\r\n    width: 60px;\r\n    line-height: 60px;\r\n    border-radius: 50%;\r\n    margin-bottom: 10px;\r\n}\r\n#activeIcon1 {\r\n  font-size: 50px;\r\n  color: rgb(255, 255, 255);\r\n  margin-top: 30px;\r\n}\r\n#normalIcon1 {\r\n  font-size: 50px;\r\n  color: rgb(255, 255, 255);\r\n  margin-top: 30px;\r\n}\r\n#normalIcon {\r\n  font-size: 24px;\r\n  color: rgb(255, 255, 255);\r\n  margin-top: 25px;\r\n}\r\n#inActiveTab {\r\n  background-color: rgb(243, 242, 238);\r\n  border-radius: 50%;\r\n  text-align: center;\r\n}\r\n#inActiveArrow {\r\n  font-size: 50px;\r\n  color: rgb(243, 242, 238);\r\n  margin-top: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
